// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PU45T"};